<template>
    <tr v-bind:key="'data-row'+index" >
        <td>{{index+1}}</td>
        <td>
            <ResolveDate
                isType="date"
                v-on:changeDate="changeDate($event, row)"
                name="date"
                v-bind:type="row.type"
                v-bind:data="getTimeformat(row.data.transform.date, true, false)" />
        </td>
        <td>
            <ResolveTime
                v-on:changeTime="changeTime($event, row)"
                name="hours"
                isType="date"
                v-bind:type="row.type"
                v-bind:data="isValidTimeString(row.data.transform.hours) || getTimeformat(row.data.transform.hours, false, true)" />
        </td>
        <td>
            <ResolveByList
                name="provider"
                v-on:onSelect="onOptionSelect($event, row)"
                isType="invalid_provider"
                v-bind:type="row.type"
                v-bind:optionList="providers"
                valueKey="provider"
                v-bind:initialValue="response[row.data.id] ? response[row.data.id].data.solution.provider : ''"
                v-bind:data="row.data.transform.doctorName || false"
                placeholder="Select doctor" />
        </td>
        <td>
            <ResolveByText
                v-on:changeText="changeText($event, row)"
                name="name"
                isType="name"
                v-bind:type="row.type"
                v-bind:data="row.data.transform.name || false"
                v-bind:initialValue="response[row.data.id] ? response[row.data.id].data.solution.name : ''"
                placeholder="Enter name" />
        </td>
        <td>
            <ResolveByText v-on:changeText="changeText($event, row)"
                name="email"
                inputType="email"
                isType="email"
                v-bind:type="row.type"
                v-bind:data="row.data.transform.email || false"
                v-bind:initialValue="response[row.data.id] ? response[row.data.id].data.solution.email : ''"
                placeholder="Enter email address" />
        </td>
        <td>
            <ResolveByText
                v-on:changeText="changeText($event, row)"
                name="phone"
                isType="phone"
                v-bind:type="row.type"
                v-bind:data="row.data.transform.phone || false"
                v-bind:initialValue="response[row.data.id] ? response[row.data.id].data.solution.phone : ''"
                placeholder="Enter phone no." />
        </td>
        <td>
            <ResolveByList name="event"
                v-bind:groupped="true"
                v-on:onSelect="onOptionSelect($event, row)"
                v-bind:isType="row.type"
                valueKey="id"
                v-bind:initialValue="response[row.data.id] ? ((response[row.data.id].data.solution.event && typeof response[row.data.id].data.solution.event === 'string') ? response[row.data.id].data.solution.event : '') : ''"
                v-bind:optionList="getApointmentList(row.data.transform.event, row.data.transform.provider, row.data.problem)"
                v-bind:type="row.type"
                v-bind:data="Object.keys(row.data.transform.event).length > 0 ? 'true' : false"
                placeholder="Select appointment" />
        </td>
        <td>
            <ResolveByText
                v-on:changeText="changeText($event, row)"
                name="notes"
                isType="notes"
                inputType="textarea"
                v-bind:type="row.type"
                v-bind:data="row.data.transform.notes || false"
                v-bind:initialValue="response[row.data.id] ? response[row.data.id].data.solution.notes : ''"
                placeholder="Enter Comments" />
        </td>
        <td style="text-align: right;">
            <a @click="ignoreSingleRow(row.data)" href="javascript:void(0)"
                style="display: inline-block;">
                <CancelIcon />
            </a>
        </td>
    </tr>
</template>

<script>
import {
        mapActions,
        mapState
    } from "vuex"
import getTimeformat from "./../util/getTimeformat"

import CancelIcon from "./CancelIcon"
import ResolveDate from "./resolveDate"
import ResolveTime from "./resolveTime"
import ResolveByList from "./resolveByList"
import ResolveByText from "./resolveByText"

export default {
    name: 'resolve-row',

    props: {
        index: {
            type: Number,
            required: true
        },
        row: {
            type: Object,
            required: true
        },
        response: {
            type: Object,
            required: true
        },
        mappedEvents: {
            type: Array,
            required: true
        }
    },

    methods: {
        ...mapActions('provider', [
            'ignoreImportError',
        ]),
        getTimeformat: getTimeformat,
        isValidTimeString(date) {
            const str = `${date}`.toLowerCase().trim()
            const lastWords = str.slice(-2)
            if (lastWords === "am" || lastWords === "pm") {
                return date
            }
            return false
        },
        getApointmentList(obj = {}, providerId, problem) {
            try {
                let evIds
                if(Array.isArray(problem) && problem.length === 1 && 
                    Array.isArray(problem[0].key) && problem[0].key.length === 1 && problem[0].key[0] === 'multiple_matches'
                    && problem[0].data.schedule && Array.isArray(problem[0].data.schedule.match))
                    evIds = problem[0].data.schedule.match
                else {
                    const highestMatch = Object.values(obj).reduce((highestVal, currentVal) => highestVal > currentVal ? highestVal : currentVal, 0)
                    evIds = Object.keys(obj).filter((key) => obj[key] === highestMatch)
                }
                
                if(evIds.length > 0 && providerId) { // multiple_matches, send grouped response
                    const events = JSON.parse(JSON.stringify(this.mappedEvents.filter(p => p.provider === providerId)))
                    const possibleMatches = []
                    events.forEach(function (ev) {
                        if (ev.options.length > 0) {
                            ev.options = ev.options.filter(function (op) {
                                if (evIds.indexOf(op.id) > -1) {
                                    possibleMatches.push(op)
                                    return false
                                }
                                return true
                            })
                        }
                    })
                    return [{
                        provider: providerId,
                        options: possibleMatches,
                        label: "Suggested"
                    }, ...events]
                }
                if(providerId) {
                    return this.mappedEvents.filter(p => p.provider === providerId)
                }
                return this.mappedEvents
            } catch (error) {
                console.error("Problem calculating appointment list ", error)
                 if(providerId) {
                    return this.mappedEvents.filter(p => p.provider === providerId)
                }
                return this.mappedEvents
            }
        },
        changeDate(ev, row) {
            this.makeResolveResponse(ev.name, ev.event, row)
        },
        changeTime(ev, row) {
            this.makeResolveResponse(ev.name, ev.event, row)
        },
        changeText(ev, row) {
            this.makeResolveResponse(ev.name, ev.event, row)
        },
        onOptionSelect(ev, row) {
            if (ev.type === "invalid_provider" && ev.name === "provider") {
                console.log(row.data.transform)
                const providerId = ev.item.provider
                row.data.transform = {
                    ...row.data.transform,
                    doctorName: ev.item.name,
                    provider: providerId
                }
                this.makeResolveResponse("event", "", row)
                this.makeResolveResponse("provider", providerId, row)
                return this.makeResolveResponse("doctorName", ev.item.name, row)
            }
            if(ev.name === "event") {
                row.data.transform = {
                    ...row.data.transform,
                    doctorName: ev.item.doctorName,
                    provider: ev.item.provider
                }
            }
            return this.makeResolveResponse(ev.name, ev.item.id, row)
        },
        makeResolveResponse( key, value, row) {
            this.$emit('make-resolve-response', key, value, row)
        },
        ignoreSingleRow(row) {
            const res = {
                "record": [{
                    "key": {
                        "provider": row.provider,
                        "id": row.id
                    },
                    "data": {
                        "ignore_record": true
                    }
                }],
                "type": "patch_record"
            }
            this.ignoreImportError(res)
        },
    },

    computed: {
         ...mapState('provider', [
            'importErrors',
            'importMapping',
            'providers',
            'provider',
            'ignoringErrorIds',
            'resolvedErrorCount',
            'profile'
        ]),
    },

    components: {
        ResolveDate,
        ResolveTime,
        ResolveByList,
        CancelIcon,
        ResolveByText,
    }
}
</script>

<style scoped lang="scss">
@import "style.scss";
</style>